module.exports = "<app-layout></app-layout>"